import React from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as $ from 'jquery';
import TooltipComponent from '../../../../../../itrust_common/components/others/TooltipComponent';
import useInsuranceMappedFailed from '../useInsuranceMappedFailed';
import { eligibilityProcessingKey } from '../../../../../../redux/reducers/addOns/rpa/vision_insurance/visionInsuranceReducer';

function RPAVerifyButton(props) {
  const { visionInsuranceConfig, handleVerifyInsurance, eligibilityProcessing, pprops: { selectedInsuranceName, btnClasses, insuranceType, wrapperClasses, insuranceVerifying, requirementsLoading, missingFields = [], requirementsError, patientId, patient, isOrderView } } = props
  const history = useHistory()
  const { rpaVerificationFailed, insuranceVerificationFailed } = useInsuranceMappedFailed(selectedInsuranceName)
  const requirementsBlocked = requirementsLoading || missingFields.length > 0 || requirementsError
  const processing = !!eligibilityProcessing?.[eligibilityProcessingKey(patientId || patient?.id, insuranceType)] || insuranceVerifying === insuranceType
  const showProcessingButton = processing && !isOrderView

  const handleInactiveVerify = () => {
    history.push('/add-ons/vision-insurance/dashboard')
    $('#orderForm-modal').modal('hide');
  }

  return (
    <>
      <div className={`d-flex align-items-center flex-nowrap ${wrapperClasses}`}>
        <div className="d-flex align-items-center flex-nowrap">
          {visionInsuranceConfig?.status !== 'inactive' ?
            <>
              {rpaVerificationFailed ?
                <>
                  <button type='button' className={`btn btn-danger btn-sm ${btnClasses}`} onClick={insuranceVerificationFailed}>
                    Verify
                  </button>
                </> :
                <>
                  {!showProcessingButton &&
                    <button className={`btn btn-primary btn-sm ${btnClasses}`} type='button' disabled={requirementsBlocked || processing} onClick={handleVerifyInsurance}>
                      Verify
                    </button>
                  }
                </>
              }
            </> :
            <button type='button' className={`btn btn-primary btn-sm ${btnClasses}`} onClick={handleInactiveVerify}>
              Verify
            </button>
          }
          {!requirementsLoading && (missingFields.length > 0 || requirementsError) &&
            <TooltipComponent title={requirementsError || `Missing: ${missingFields.map(field => field.label).join(', ')}`}>
              <i className="las la-info-circle text-danger ml-2 font-size-18" />
            </TooltipComponent>}
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  const { visionInsurance, organisation: { organisation } } = state

  return {
    eligibilityProcessing: visionInsurance.eligibilityProcessing,
    visionInsuranceConfig: organisation.add_ons_config?.type?.vision_insurance
  }
}

export default connect(mapStateToProps)(RPAVerifyButton)